import {Action, Reducer} from "redux";
import {IAuditState} from "./state/AuditState";
import {initState} from "./state/InitAuditState";
import { CLEAR_AUDITS_SUCCESS, GET_AUDIT_ERROR, GET_AUDIT_START, GET_AUDIT_SUCCESS, SAVE_AUDIT_OPERATOR_INFO_SUCCESS, SAVE_AUDIT_TAGS_SUCCESS } from "./actions/types";
import { GetAuditsActionSuccess, SaveAuditTagsActionSuccess, SaveAuditsOperatorInfoActionSuccess } from "./actions/interfaces";

export type KnownActions = any;

export const auditReducer: Reducer<IAuditState> = (
    state: IAuditState = initState, 
    incommingAction: Action
): IAuditState => {
    const action = incommingAction as KnownActions;
    switch(action.type) {

        case GET_AUDIT_START: {
            return {
                ...state,
                auditList: {
                    ...state.auditList,
                    isReceivingAudits: true
                }
            };
        }

        case CLEAR_AUDITS_SUCCESS: {
            return {
                ...state,
                auditList: {
                    ...state.auditList,
                    audits: []
                }
            };
        }

        case GET_AUDIT_SUCCESS: {
            const audits = (action as GetAuditsActionSuccess).payload.audits;

            const allAudits = state.auditList.audits.concat(audits);

            return {
                ...state,
                auditList: {
                    ...state.auditList,
                    audits: allAudits,
                    isReceivingAudits: false
                }
            };
        }

        case GET_AUDIT_ERROR: {
            return {
                ...state,
                auditList: {
                    ...state.auditList,
                    isReceivingAudits: false
                }
            };
        }

        case SAVE_AUDIT_OPERATOR_INFO_SUCCESS: {
            const operators = (action as SaveAuditsOperatorInfoActionSuccess).payload.operators;

            return {
                ...state,
                auditList: {
                    ...state.auditList,
                    operators
                }
            };
        }

        case SAVE_AUDIT_TAGS_SUCCESS: {
            const tags = (action as SaveAuditTagsActionSuccess).payload.tags;

            return {
                ...state,
                auditList: {
                    ...state.auditList,
                    audits: [],
                    auditTags: tags
                }
            };
        }
        
        default:
            return state;
    }
};
